import { render } from "./Main.vue?vue&type=template&id=c3e42768&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=c3e42768&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c3e42768"

export default script